import React from "react"
import { Skeleton } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { X } from "lucide-mui"

interface LoadingProps {
  onClose: () => void
}

const Loading: React.FC<LoadingProps> = ({ onClose }) => {
  return (
    <div data-testid="panel-clients-modal-loading-container" className="flex flex-1 min-h-[50vh]">
      <div className="flex flex-col bg-gray-50 p-6" style={{ flex: "0 0 40%" }}>
        <div className="flex flex-col h-full">
          <div className="flex flex-row">
            <div className="flex flex-1 items-start mb-6">
              <Skeleton variant="circular" width={64} height={64} />
              <div className="ml-4 flex-1">
                <Skeleton variant="text" width="60%" height={32} className="mb-2" />
                <Skeleton variant="text" width="80%" height={20} className="mb-1" />
                <Skeleton variant="text" width="70%" height={20} />
              </div>
            </div>
            <div>
              <Skeleton variant="rectangular" width={80} height={32} className="rounded" />
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg mb-4">
            <Skeleton variant="rectangular" width="100%" height={200} />
          </div>
        </div>
      </div>

      <div className="flex flex-col flex-1 relative min-h-0" style={{ flex: "0 0 60%" }}>
        <div className="absolute top-2 right-2 z-10">
          <IconButton data-testid="panel-clients-modal-loading-close" onClick={onClose} color="inherit" size="small">
            <X className="text-lg" />
          </IconButton>
        </div>

        <div className="w-full h-full flex flex-col min-h-0">
          <div className="border-b border-gray-200 pt-4 px-6 flex-shrink-0">
            <div className="flex gap-4">
              <Skeleton variant="text" width={100} height={48} />
              <Skeleton variant="text" width={120} height={48} />
            </div>
          </div>
          <div className="flex-1 overflow-y-auto min-h-0 p-6">
            <Skeleton variant="text" width="100%" height={24} className="mb-2" />
            <Skeleton variant="text" width="90%" height={24} className="mb-2" />
            <Skeleton variant="text" width="95%" height={24} className="mb-4" />
            <Skeleton variant="rectangular" width="100%" height={120} className="mb-4" />
            <Skeleton variant="text" width="100%" height={24} className="mb-2" />
            <Skeleton variant="text" width="85%" height={24} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loading
